import { ChangeEvent, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  //AdminPageHeader,
  ButtonPropsTypes,
  ButtonStyles,
  ButtonSize,
  // Card,
  // HeaderStyle,
  useBreakpoint,
  Button,
  Input,
  InputTypes,
  InputValidations,
  MLPVersion,
  Modal,
  PhoneNumber,
  ProfileImage,
  Theme,
  DropDown,
  DropDownValidations,
  ButtonTypes,
} from '../../../ui/components';
import { LoggerService, processProfilePictureData } from '../../../ui/utils';
import { customEventPropType } from '../../../ui/components/ImageEditor/types/propsType';
import RemoveButton from '../../../assets/image/icons/remove_button.svg';
import ChangeButton from '../../../assets/image/icons/change_button.svg';
import ProfilePhotoUpload from '../../../assets/image/ProfileImageUpload.svg';
import userService from '../../../sdk/services/userService';
import type { DynamicObjectInterface } from '../../../sdk/type';
import ImageEditor from '../../../ui/components/ImageEditor/ImageEditor';
import { formatCampaignId, isValidEmail } from '../../../ui/utils/common';
import { useAPICall } from '../../../hooks';
import AttachmentService from '../../../sdk/services/attachmentService';
import { DropDownData } from '../../../ui/components/Form/DropDown/types/propsType';
import { countryCodeNumber } from '../../../__mockData/phoneNumber';
import { states } from '../../../__mockData/states';
import { useAdminToast } from '../../../ui/components/AdminToast/AdminToast';
import OTPModal from '../../../ui/components/OTPModal';
import { getContent } from '../../../sdk/services/contentService';
import { REACT_APP_COUNTRY } from '../../../envVars';
import styles from './index.module.scss';

interface UserData {
  userId: string;
  email: string;
  phone: string;
  loginId: string;
  frameworkRole: string;
  memberType: string;
  isPrimary: string;
  name: string;
  gender: string;
  status: string;
  address: string;
  state: string;
  occupation: string;
  incomeRange: string;
  emailVerified: number;
  [key: string]: string | number | undefined;
}

export const EditPersonalDetails = (props: { decodedData: DynamicObjectInterface }) => {
  const [urlParamValue, setUrlParamValue] = useState({
    campaignId: '',
    teamId: '',
    userId: '',
  });

  const [data, setData] = useState<UserData | null>(null);
  const [showProfileUploadModal, setShowModal] = useState(false);
  const [isOpenVerifyEmailDrawer, setIsOpenVerifyEmailDrawer] = useState(false);
  const [profileImageUrl, setProfileImageUrl] = useState<string | undefined>('');
  const [profileImageFile, setProfileImageFile] = useState<File | null>(null);
  const [dropdownValue, setDropdownValue] = useState('');
  const [phoneValue, setPhoneValue] = useState('');
  const [phoneValid, setPhoneValid] = useState(true);
  const [emailValid, setEmailValid] = useState(true);
  const [isProfileImageDeleted, setIsProfileImageDeleted] = useState(false);
  // const [showHead, setShowHead] = useState(false);
  const viewPortType = useBreakpoint();
  const isDesktopView = ['xs', 'sm', 'md'].indexOf(viewPortType) === -1;
  const [gender, setGender] = useState('');
  const apiCall = useAPICall();
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { adminToast } = useAdminToast();
  const [clickedFields, setClickedFields] = useState({
    loginId: false,
    name: false,
    frameworkRole: false,
    memberType: false,
    email: false,
    phone: false,
    address: false,
    state: false,
    occupation: false,
    incomeRange: false,
  });
  const [requiredEmailOtp, setRequiredEmailOtp] = useState(false);
  const [lastVerifiedEmail, setLastVerifiedEmail] = useState<string>();

  const [countdown, setCountdown] = useState<number>(0);
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  const startCountdown = () => {
    if (countdown > 0) return;
    setCountdown(60);
  };

  useEffect(() => {
    if (countdown > 0) {
      timerRef.current = setTimeout(() => {
        setCountdown(prev => prev - 1);
      }, 1000);
    } else if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [countdown]);

  // console.log(setShowHead);
  useEffect(() => {
    if (data?.phone) {
      const [countryCode, number] = data.phone.split(' ');
      setDropdownValue(countryCode);
      setPhoneValue(number);
      if (number) {
        if (REACT_APP_COUNTRY === 'ID') {
          setPhoneValid(!(number.length > 0 && (number.length < 8 || number.length > 12)));
        } else {
          setPhoneValid(!(number.length > 0 && (number.length < 8 || number.length > 10)));
        }
      } else {
        setPhoneValid(false);
      }
    }

    if (data?.email) {
      setEmailValid(isValidEmail(data.email));
    }
  }, [data]);

  useEffect(() => {
    setUrlParamValue(prev => {
      const params = new URLSearchParams(location.search);
      const userId = params.get('id') ?? '';
      prev.userId = userId;
      return { ...prev };
    });
    fetchData();
    fetchProfileImage();
    getEmailOtpSettings();
  }, [location]);

  const fetchData = async () => {
    const res = await apiCall(userService.getUserDetails, urlParamValue.userId);
    if (res.data.data) {
      let _data = res.data.data;
      setData(_data);
      setLastVerifiedEmail(_data?.emailVerified === 1 ? _data?.email : '');
    }
  };

  const fetchProfileImage = async () => {
    try {
      const response = await AttachmentService.downloadProfileImage(urlParamValue.userId.toString() ?? '');
      if (response.data && response.data.data && response.data.data.image) {
        setProfileImageUrl(response.data.data.image);
      }
    } catch (error) {
      LoggerService.log('Error downloading image', error);
    }
  };

  useEffect(() => {
    if (data) {
      const { phone } = data;
      if (phone) {
        const [countryCode, number] = phone.split(' ');
        setDropdownValue(countryCode);
        setPhoneValue(number);
      }
      //need change
      setGender(gender);
    }
  }, [data]);

  const cacheKey = 'emailOtp';
  const getEmailOtpSettings = async () => {
    try {
      const data = await getContent('email_otp', cacheKey, false);

      setRequiredEmailOtp(data);
    } catch (error) {
      LoggerService.log('Failed to retrieve content data. Using default content.');
    }
  };

  const deleteProfile = () => {
    setProfileImageUrl('');
    setIsProfileImageDeleted(true);
  };

  const handleFileImage = (e: customEventPropType, view: string) => {
    const file = e.files[0];
    setProfileImageFile(file);
    const objectUrl = URL.createObjectURL(file);
    setProfileImageUrl(objectUrl);
    setShowModal(false);
    setIsProfileImageDeleted(false);
  };

  const handleFileUpload = async () => {
    try {
      if (profileImageFile && urlParamValue?.userId) {
        const formData = processProfilePictureData(profileImageFile, urlParamValue.userId);
        const response = await apiCall(() => AttachmentService.postUploadProfile(formData));
        if (!response || response.status !== 200) {
          adminToast({
            message: t('dashboard.profile.message.failedToUploadProfileImage'),
            theme: Theme.ERROR,
          });
        }
      }
    } catch (error) {
      adminToast({
        message: t('dashboard.profile.message.failedToUploadProfileImage'),
        theme: Theme.ERROR,
      });
      LoggerService.log('Error uploading file', error);
    }
  };

  const handleFileDelete = async () => {
    try {
      if (isProfileImageDeleted && urlParamValue?.userId) {
        const payload = {
          loginId: urlParamValue?.userId,
        };
        await apiCall(AttachmentService.removeProfile, payload);
      }
    } catch (error) {
      LoggerService.log('Error uploading file', error);
    }
  };

  const handleFile = (e: ChangeEvent<HTMLInputElement>, key: string) => {
    const file = e.target.files?.[0] as File | null;

    setProfileImageFile(file);
    if (file) {
      const objectUrl = URL.createObjectURL(file);
      setProfileImageUrl(objectUrl);
    } else {
      setProfileImageUrl('');
    }
    setShowModal(false);
    setIsProfileImageDeleted(false);
  };

  const uploadImageModal = (
    <>
      {showProfileUploadModal && (
        <Modal
          primaryButtonLabel={''}
          headline={t('dashboard.profile.label.uploadProfilePicture')}
          containerWidth={'550px'}
          containerHeight={'570px'}
          closeIcon={true}
          onClose={() => setShowModal(false)}
        >
          <div>
            {profileImageUrl ? (
              <div className={styles['profile-image-container']}>
                <div className={styles['image-wrapper']}>
                  <img
                    src={profileImageUrl}
                    alt={t('dashboard.profile.label.beforeFrontViewImgAlt')}
                    className={styles['profile-image']}
                    style={{ borderRadius: '50%' }}
                  />
                </div>
                <div className={styles['buttons-container']}>
                  <button
                    className={styles['change-photo']}
                    onClick={() => document.getElementById('profileImageUrl')?.click()}
                  >
                    <img src={ChangeButton} alt="bg" />
                    <input
                      type="file"
                      id="profileImageUrl"
                      accept="image/*"
                      onChange={e => handleFile(e, 'profileImageUrl')}
                      style={{ display: 'none' }}
                    />
                  </button>
                  <button className={styles['remove-photo']} onClick={() => deleteProfile()}>
                    <img src={RemoveButton} alt="bg" />
                  </button>
                </div>
              </div>
            ) : (
              <ImageEditor onFileUpload={e => handleFileImage(e, 'file')} accept="image/*" />
            )}
          </div>
        </Modal>
      )}
    </>
  );

  const saveChanges = async () => {
    try {
      // Example: Update API call
      if (!isValidateInputs()) {
        adminToast({
          message: t('dashboard.profile.message.enterMandatoryField'),
          theme: Theme.ERROR,
        });
        return;
      }
      const response = await apiCall(userService.updateUserProfile, `${urlParamValue.userId}`, data);
      if (response.status === 200) {
        navigate(`/profile?id=` + urlParamValue.userId);
        window.location.reload();
      } else {
        // Handle error
      }
    } catch (error) {
      LoggerService.log('Error updating participant details', error);
    }
  };

  const isValidateInputs = (): boolean => {
    let isValid = false;
    if (
      emailValid &&
      phoneValid &&
      phoneValue &&
      data?.name !== '' &&
      data?.email !== '' &&
      data?.gender !== null &&
      data?.gender !== '' &&
      (data?.emailVerified === 1 || !requiredEmailOtp) &&
      (REACT_APP_COUNTRY !== 'MY' || (data?.race !== null && data?.race !== '')) // always be true for ID since this is not required
    ) {
      isValid = true;
    }
    return isValid;
  };

  const buttonConfig: ButtonPropsTypes[] = [
    {
      title: t('dashboard.profile.button.cancel'),
      buttonStyle: ButtonStyles.OUTLINE,
      theme: Theme.GREEN,
      onClick: () => {
        navigate(`/profile?id=` + urlParamValue.userId);
      },
    },
    {
      title: t('dashboard.profile.button.save'),
      buttonStyle: ButtonStyles.SOLID,
      theme: Theme.GREEN,
      disabled: !isValidateInputs(),
      onClick: () => {
        if (profileImageUrl) {
          handleFileUpload();
        } else {
          handleFileDelete();
        }
        if (formatCampaignId(urlParamValue.userId ?? '')) {
          saveChanges();
        } else {
          adminToast({
            message: t('dashboard.profile.message.invalidLoginIdFormat'),
            theme: Theme.ERROR,
          });
        }
      },
    },
  ];

  const handleInputChange = (name: string, value: DynamicObjectInterface) => {
    setData(prevUserData => ({
      ...prevUserData!,
      [name]: value,
    }));

    setClickedFields(prevClickedFields => ({
      ...prevClickedFields,
      [name]: value === '',
    }));

    if (name === 'email') {
      setEmailValid(isValidEmail(value as string));
    }

    if (name === 'phoneNumber' && value === '') {
      setPhoneValid(false);
    }
  };

  // const downloadOther = async() => {
  //   const payload = {
  //     loginId: "19",
  //     campaignId: "BodyKeyGutFit2023",
  //     teamId: "1"
  //   };

  //   try {
  //     const response =  await apiCall(AttachmentService.downloadOther, payload);
  //     console.log(response)
  //     if (response.status === 200) {
  //       let filename =  'output.zip';
  //       const data = response.data;
  //       var disposition = response.headers.get('Content-Disposition');
  //       console.log(disposition)
  //       if (disposition) {
  //         var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
  //         var matches = filenameRegex.exec(disposition);
  //         if (matches != null && matches[1]) {
  //           filename = matches[1].replace(/['"]/g, '');
  //         }
  //       }

  //       const blob = new Blob([data], { type: "octet/stream" });
  //       const link = document.createElement('a');
  //       const url = URL.createObjectURL(blob);
  //       link.href = url;
  //       link.download = filename;
  //       document.body.appendChild(link);
  //       link.click();
  //       document.body.removeChild(link);

  //       // Release the object URL resources
  //       URL.revokeObjectURL(link.href);
  //     }
  //   } catch (error) {
  //     LoggerService.log('Error exporting CSV', error);
  //   }
  // }

  const handleRequestOTP = async (mode?: string) => {
    if (mode === 'new') {
      setIsOpenVerifyEmailDrawer(true);
    }

    if (countdown <= 0) {
      const payload = {
        email: data?.email,
        country: REACT_APP_COUNTRY?.toLowerCase(),
        channel: 'email',
      };

      const res = await apiCall(userService.requestOTP, payload);
      if (res.result) {
        startCountdown();
        adminToast({
          message: 'A one-time password (OTP) has been sent to your email address.',
          theme: Theme.SUCCESS,
        });
        return true;
      }
    }
    return false;
  };

  const handleVerifyEmail = async (otpCode: string) => {
    //call verify email
    const payload = {
      otpCode: otpCode,
      email: data?.email,
      country: REACT_APP_COUNTRY?.toLowerCase(),
    };

    const res = await apiCall(userService.verifyOTP, payload);

    if (res.result && res.data?.isValid === true) {
      handleInputChange('emailVerified', 1);
      setLastVerifiedEmail(data?.email);
      setIsOpenVerifyEmailDrawer(false);
      return true;
    } else {
      return false;
    }
  };

  const genderOptions = [
    { value: 'MALE', title: t('dashboard.profile.input.dropdown.male') },
    { value: 'FEMALE', title: t('dashboard.profile.input.dropdown.female') },
  ];

  return (
    <div>
      {/* {showHead && <AdminPageHeader title={t('admin.profile.editPersonalInfo')} button={buttonConfig} />} */}
      <div className={styles['card']}>
        <div className={styles['card-header']}>
          <h2>{t('dashboard.profile.label.editPersonalInfo')}</h2>
          {isDesktopView && (
            <div className={styles['edit-register-button']}>
              {buttonConfig.map(btn => (
                <Button key={btn.title} size={ButtonSize.SMALL} {...btn} />
              ))}
            </div>
          )}
        </div>
        <div className={styles['edit-personal-details']}>
          <div className={styles['form']}>
            <div className={styles['profile-container']}>
              <ProfileImage
                placeholder={data?.name ?? ''}
                src={profileImageUrl ? profileImageUrl : ProfilePhotoUpload}
              />
              <div className={styles['buttons-container']}>
                <button
                  className={styles['change-photo']}
                  onClick={() => document.getElementById('profileImageUrl')?.click()}
                >
                  <img src={ChangeButton} alt="bg" />
                  <input
                    type="file"
                    id="profileImageUrl"
                    accept="image/*"
                    onChange={e => handleFile(e, 'profileImageUrl')}
                    style={{ display: 'none' }}
                  />
                </button>
                <button className={styles['remove-photo']} onClick={() => deleteProfile()}>
                  <img src={RemoveButton} alt="bg" />
                </button>
              </div>
            </div>
            <div className={styles['input-container-four-column']}>
              <div className={styles['input-section']}>
                <Input
                  id="id"
                  disabled={true}
                  type={InputTypes.TEXT}
                  name={'name'}
                  placeholder={t('dashboard.profile.input.placeholder.name')}
                  label={`${t('dashboard.profile.input.name')}`}
                  value={data?.name}
                  mlpVersion={MLPVersion.ONE}
                  onChange={e => {
                    handleInputChange('name', e.target.value);
                  }}
                  onClick={() =>
                    setClickedFields(prevClickedFields => ({ ...prevClickedFields, name: data?.name === '' }))
                  }
                  status={clickedFields.name ? InputValidations.INVALID : InputValidations.DEFAULT}
                  required={true}
                />
              </div>
              <div className={styles['input-section']}>
                <Input
                  disabled={true}
                  type={InputTypes.TEXT}
                  name={'loginId'}
                  placeholder={t('dashboard.profile.input.placeholder.aboId')}
                  label={`${t('dashboard.profile.input.aboId')}`}
                  value={data?.loginId}
                  mlpVersion={MLPVersion.ONE}
                  status={clickedFields.loginId ? InputValidations.INVALID : InputValidations.DEFAULT}
                  required={true}
                />
              </div>
              <div className={styles['input-section']}>
                <DropDown
                  name="gender"
                  dropdownLabel={`${t('dashboard.profile.input.gender')}`}
                  disabledFilter
                  status={data?.gender ? DropDownValidations.DEFAULT : DropDownValidations.INVALID}
                  mlpVersion={MLPVersion.ONE}
                  value={
                    data?.gender ? genderOptions.find(option => option.value === data.gender.toUpperCase())?.title : ''
                  }
                  data={genderOptions}
                  configData={{
                    label: 'title',
                    onSelect: (selectedOption: DropDownData) => {
                      handleInputChange('gender', selectedOption.value);
                    },
                  }}
                  required={true}
                />
                {data?.gender === '' ? (
                  <div className={styles['text-error-message']}>{t('dashboard.profile.message.requiredGender')}</div>
                ) : null}
              </div>
              <div className={styles['input-section']}>
                {REACT_APP_COUNTRY === 'MY' ? (
                  <>
                    <DropDown
                      name="race"
                      dropdownLabel={`${t('dashboard.profile.input.race')}`}
                      disabledFilter
                      status={data?.race ? DropDownValidations.DEFAULT : DropDownValidations.INVALID}
                      mlpVersion={MLPVersion.ONE}
                      value={
                        data?.race
                          ? String(data?.race)?.charAt(0).toUpperCase() + String(data?.race)?.slice(1).toLowerCase()
                          : ''
                      }
                      data={[
                        { value: 'CHINESE', title: t('dashboard.profile.input.dropdown.chinese') },
                        { value: 'MALAY', title: t('dashboard.profile.input.dropdown.malay') },
                        { value: 'INDIAN', title: t('dashboard.profile.input.dropdown.indian') },
                        { value: 'OTHER', title: t('dashboard.profile.input.dropdown.others') },
                      ]}
                      configData={{
                        label: 'title',
                        onSelect: (selectedOption: DropDownData) => {
                          handleInputChange('race', selectedOption.value);
                        },
                      }}
                      required={true}
                    />
                    {data?.race === '' ? (
                      <div className={styles['text-error-message']}>{t('dashboard.profile.message.requiredRace')}</div>
                    ) : null}
                  </>
                ) : null}
              </div>

              <div className={styles['input-section']}>
                <div className={styles['input-label']}>
                  {`${t('dashboard.profile.input.contactNo')}`}
                  <span className={styles['label-red']}>*</span>
                </div>
                <PhoneNumber
                  name={'phoneNumber'}
                  data={countryCodeNumber}
                  inputValue={phoneValue}
                  dropdownValue={dropdownValue}
                  placeholder={t('dashboard.profile.input.placeholder.contactNo')}
                  status={(!phoneValid || phoneValue.length === 0) ? InputValidations.INVALID : InputValidations.DEFAULT}
                  message={
                    phoneValue.length === 0
                      ? t('dashboard.profile.message.requiredPhoneNumber')
                      : !phoneValid
                        ? t('dashboard.profile.message.invalidPhoneNumber')
                        : ''
                  }
                  configData={{
                    label: 'name',
                    onSelect: (e: DropDownData) => {
                      setDropdownValue(e.name as string);
                      if (e.name) {
                        let _phoneValue = phoneValue;

                        // Remove leading 0 if country code exists
                        if (phoneValue?.startsWith('0')) {
                          _phoneValue = phoneValue.slice(1);
                        }

                        const combinedValue = `${e.name} ${_phoneValue}`;
                        setPhoneValue(_phoneValue === '' ? '' : _phoneValue);
                        handleInputChange('phone', combinedValue);
                      } else {
                        setPhoneValue('');
                        handleInputChange('phone', '');
                      }
                    },
                  }}
                  onInputChange={val => {
                    let phoneNumber = val ?? '';

                    // Remove leading 0 if country code exists
                    if (!!dropdownValue && phoneNumber?.startsWith('0')) {
                      phoneNumber = phoneNumber.slice(1);
                    }

                    setPhoneValue(phoneNumber);
                    if (phoneNumber) {
                      const combinedValue = `${dropdownValue} ${phoneNumber}`;
                      setPhoneValue(phoneNumber === '' ? '' : phoneNumber);
                      handleInputChange('phone', combinedValue);
                    } else {
                      setPhoneValue('');
                      handleInputChange('phone', '');
                    }
                  }}
                  required={true}
                  maxLength={REACT_APP_COUNTRY === 'ID' ? 12 : 10}
                />
              </div>
              <div className={styles['input-section']}>
                <Input
                  key=""
                  //disabled={true}
                  type={InputTypes.EMAIL}
                  name={'email'}
                  placeholder="john_doe@domainname.com"
                  label={`${t('dashboard.profile.input.email')}`}
                  value={data?.email}
                  mlpVersion={MLPVersion.ONE}
                  onChange={e => {
                    const value = e.target.value;
                    handleInputChange('email', value);
                    handleInputChange('emailVerified', value === lastVerifiedEmail ? 1 : 0);
                  }}
                  onClick={() =>
                    setClickedFields(prevClickedFields => ({ ...prevClickedFields, email: data?.email === '' }))
                  }
                  status={
                    data?.email === '' || !emailValid
                      ? InputValidations.INVALID
                      : data?.emailVerified === 1 && requiredEmailOtp
                        ? InputValidations.VALID
                        : requiredEmailOtp
                          ? InputValidations.WARNING
                          : InputValidations.DEFAULT
                  }
                  message={
                    data?.email === ''
                      ? t('dashboard.profile.message.requiredEmail')
                      : data?.emailVerified === 1 && requiredEmailOtp
                        ? t('dashboard.profile.message.emailVerified')
                        : emailValid && requiredEmailOtp
                          ? t('dashboard.profile.message.clickVerifyEmail')
                          : emailValid
                            ? ''
                            : t('dashboard.profile.message.invalidEmailFormat')
                  }
                  required={true}
                />
              </div>
              {requiredEmailOtp && data?.emailVerified !== 1 && (
                <Button
                  className={styles['verify-order']}
                  title={t('dashboard.profile.button.verifyEmail')}
                  type={ButtonTypes.BUTTON}
                  onClick={() => handleRequestOTP('new')}
                  buttonStyle={ButtonStyles.SOLID}
                  size={ButtonSize.SMALL}
                  theme={Theme.GREEN}
                  data-testid="primary-button-test-id"
                  disabled={data?.email === '' || !emailValid}
                />
              )}
            </div>
            <div className={styles['input-container']}>
              <div className={styles['input-section-address']}>
                <Input
                  key="id"
                  type={InputTypes.TEXT}
                  name={'address'}
                  placeholder=""
                  label={`${t('dashboard.profile.input.address')}`}
                  value={data?.address}
                  mlpVersion={MLPVersion.ONE}
                  onChange={e => {
                    handleInputChange('address', e.target.value);
                  }}
                  onClick={() =>
                    setClickedFields(prevClickedFields => ({ ...prevClickedFields, address: data?.address === '' }))
                  }
                  status={clickedFields.address ? InputValidations.INVALID : InputValidations.DEFAULT}
                />
              </div>
              <div className={styles['input-section']}>
                {REACT_APP_COUNTRY === 'MY' ? (
                  <DropDown
                    name="state"
                    dropdownLabel={`${t('dashboard.profile.input.state')}`}
                    disabledFilter
                    mlpVersion={MLPVersion.ONE}
                    status={data?.occupation ? DropDownValidations.DEFAULT : DropDownValidations.INVALID}
                    isWithinModal={false}
                    value={data?.state || ''}
                    data={states}
                    configData={{
                      label: 'title',
                      onSelect: (selectedOption: DropDownData) => {
                        handleInputChange('state', selectedOption.value);
                      },
                    }}
                  />
                ) : null}
              </div>
            </div>
            <div className={styles['input-container-three-column']}>
              <div className={styles['input-section']}>
                {REACT_APP_COUNTRY === 'MY' ? (
                  <>
                    <DropDown
                      name="occupation"
                      dropdownLabel={`${t('dashboard.profile.input.occupation')}`}
                      disabledFilter
                      status={data?.occupation ? DropDownValidations.DEFAULT : DropDownValidations.INVALID}
                      mlpVersion={MLPVersion.ONE}
                      isWithinModal={false}
                      value={data?.occupation || ''}
                      data={[
                        { value: 'Full Time ABO', title: t('dashboard.profile.input.dropdown.fullTimeABO') },
                        { value: 'Business and Sales', title: t('dashboard.profile.input.dropdown.businessAndSales') },
                        {
                          value: 'Education and Training',
                          title: t('dashboard.profile.input.dropdown.educationAndTraining'),
                        },
                        { value: 'Healthcare', title: t('dashboard.profile.input.dropdown.healthcare') },
                        { value: 'Engineering and IT', title: t('dashboard.profile.input.dropdown.engineeringAndIT') },
                        { value: 'Legal and Finance', title: t('dashboard.profile.input.dropdown.legalAndFinance') },
                        {
                          value: 'Marketing and Customer Service',
                          title: t('dashboard.profile.input.dropdown.marketingAndCustomerService'),
                        },
                        {
                          value: 'Administration and Support',
                          title: t('dashboard.profile.input.dropdown.administrationAndSupport'),
                        },
                        { value: 'Other', title: t('dashboard.profile.input.dropdown.other') },
                      ]}
                      configData={{
                        label: 'title',
                        onSelect: (selectedOption: DropDownData) => {
                          handleInputChange('occupation', selectedOption.value);
                        },
                      }}
                    />
                    {data?.occupation === '' ? (
                      <div className={styles['text-error-message']}>
                        {t('dashboard.profile.message.requiredOccupation')}
                      </div>
                    ) : null}
                  </>
                ) : null}
              </div>
              <div className={styles['input-section']}>
                {REACT_APP_COUNTRY === 'MY' ? (
                  <>
                    <DropDown
                      name="incomeRange"
                      dropdownLabel={`${t('dashboard.profile.input.incomeRange')}`}
                      disabledFilter
                      status={data?.incomeRange ? DropDownValidations.DEFAULT : DropDownValidations.INVALID}
                      mlpVersion={MLPVersion.ONE}
                      value={data?.incomeRange || ''}
                      data={[
                        { value: 'Below RM3,500', title: t('dashboard.profile.input.dropdown.below3500') },
                        { value: 'RM3,501 - RM8,000', title: t('dashboard.profile.input.dropdown.between3501And8000') },
                        {
                          value: 'RM8,001 - RM11,000',
                          title: t('dashboard.profile.input.dropdown.between8001And11000'),
                        },
                        { value: 'Above RM11,000', title: t('dashboard.profile.input.dropdown.above11000') },
                      ]}
                      configData={{
                        label: 'title',
                        onSelect: (selectedOption: DropDownData) => {
                          handleInputChange('incomeRange', selectedOption.value);
                        },
                      }}
                    />
                    {data?.incomeRange === '' ? (
                      <div className={styles['text-error-message']}>
                        {t('dashboard.profile.message.requiredIncomeRange')}
                      </div>
                    ) : null}
                  </>
                ) : null}
              </div>
            </div>
            {!isDesktopView && (
              <div className={styles['edit-register-button']}>
                {buttonConfig.map(btn => (
                  <Button key={btn.title} size={ButtonSize.SMALL} {...btn} />
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
      {uploadImageModal}
      {isOpenVerifyEmailDrawer && (
        <OTPModal
          email={data?.email ?? ''}
          onClose={() => setIsOpenVerifyEmailDrawer(false)}
          onRequestOTP={() => handleRequestOTP()}
          onVerifyOTP={handleVerifyEmail}
          countdown={countdown}
          startCountdown={startCountdown}
        />
      )}
    </div>
  );
};
